import React, { Component, useEffect } from 'react';
import { dataUser } from '../Helpers/util';
import axios from 'axios';
import { toast } from 'react-toastify';
import $ from 'jquery';
import mixpanel from 'mixpanel-browser';
import SwInput from '../Common/FormComponent/SwInput';
import SwRadio from '../Common/FormComponent/SwRadio';
import SwCheckbox from '../Common/FormComponent/SwCheckbox';

const userDataLocal = dataUser();

var UserObj = JSON.parse(userDataLocal);
var roleData = UserObj && UserObj.role_data ? UserObj.role_data : [];

const memberService = roleData.find(element => element.service_id == '1');
class AddnewRoles extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      selectAll: false,
      userRole: UserObj && UserObj.role_data ? UserObj.role_data : [],
      userid: UserObj ? UserObj.rec_id : null,
      roles: [
        {
          service_id: 1,
          service_name: 'Manage Members',
          role_for_read: false,
          role_for_write: false,
          isVisible: true,
        },
        {
          service_id: 23,
          service_name: 'Member Approvals',
          role_for_read: false,
          role_for_write: false,
          isVisible:
            roleData &&
            roleData.length > 0 &&
            roleData[0]['role_for_write'] == '1'
              ? true
              : false,
        },
        {
          service_id: 2,
          service_name: 'Seat Management',
          role_for_read: false,
          role_for_write: false,
          isVisible: true,
        },
        {
          service_id: 3,
          service_name: 'Visitor Logs',
          role_for_read: false,
          role_for_write: false,
          isVisible: true,
        },
        {
          service_id: 4,
          service_name: 'Meeting Room Inventory',
          role_for_read: false,
          role_for_write: false,
          isVisible: true,
        },
        {
          service_id: 5,
          service_name: 'Company Profile',
          role_for_read: false,
          role_for_write: false,
          isVisible: true,
        },
        {
          service_id: 6,
          service_name: 'Bills & Invoices',
          role_for_read: false,
          role_for_write: false,
          isVisible: true,
        },
        // {
        //   service_id: 7,
        //   service_name: 'Chat with Us',
        //   role_for_read: false,
        //   role_for_write: false,
        // },
        {
          service_id: 8,
          service_name: 'Parking Request',
          role_for_read: false,
          role_for_write: false,
          isVisible: true,
        },
        // {
        //   service_id: 9,
        //   service_name: 'Leasing',
        //   role_for_read: false,
        //   role_for_write: false,
        // },
        {
          service_id: 10,
          service_name: 'E-Cafeteria',
          role_for_read: false,
          role_for_write: false,
          isVisible: true,
        },
        {
          service_id: 26,
          service_name: ' Spintly Dashboard',
          role_for_read: false,
          role_for_write: false,
          isVisible: true,
        },
        {
          service_id: 12,
          service_name: 'Seat Planning',
          role_for_read: false,
          role_for_write: false,
          isVisible: true,
        },
        {
          service_id: 13,
          service_name: 'Manage Roles',
          role_for_read: false,
          role_for_write: false,
          isVisible: true,
        },
        {
          service_id: 14,
          service_name: 'Department Master',
          role_for_read: false,
          role_for_write: false,
          isVisible: true,
        },
        {
          service_id: 15,
          service_name: 'Seat Booking Analytics',
          role_for_read: false,
          role_for_write: false,
          isVisible: true,
        },
        {
          service_id: 16,
          service_name: 'Room Booking Analytics',
          role_for_read: false,
          role_for_write: false,
          isVisible: true,
        },
        {
          service_id: 17,
          service_name: 'Support Tickets',
          role_for_read: false,
          role_for_write: false,
          isVisible: true,
        },
        {
          service_id: 18,
          service_name: 'Flexi Seat Analytics',
          role_for_read: false,
          role_for_write: false,
          isVisible: true,
        },
        {
          service_id: 19,
          service_name: 'MR Analytics',
          role_for_read: false,
          role_for_write: false,
          isVisible: true,
        },

        {
          service_id: 24,
          service_name: ' Attendance Reports ',
          role_for_read: false,
          role_for_write: false,
          isVisible: true,
        },
        {
          service_id: 25,
          service_name: ' Shift Assigning ',
          role_for_read: false,
          role_for_write: false,
          isVisible: true,
        },
        {
          service_id: 27,
          service_name: 'Service Requests',
          role_for_read: false,
          role_for_write: false,
          isVisible: true,
        },
        {
          service_id: 29,
          service_name: 'Create Room Booking',
          role_for_read: false,
          role_for_write: false,
          isVisible: true,
        },
        {
          service_id: 28,
          service_name: 'Meal Plan',
          role_for_read: false,
          role_for_write: false,
          isVisible: true,
        },

        {
          service_id: 31,
          service_name: 'Access Logs',
          role_for_read: false,
          role_for_write: false,
          isVisible: true,
        },
      ],
      newArr: [],
      company_id: UserObj ? UserObj.company_id : null,
      rec_id: UserObj.rec_id,
      role_status: '1',
      action_type: 'ADD_NEW',
      org_role_id: 'NA',
      value: null,
      newuserdata: {},
      dataarrserver: [],
    };
  }

  selectAll = value => {
    this.setState({ selectAll: value });
    var newRoles = [];
    this.state.roles.map(role => {
      let isVisibility = true;
      if (role.service_id == 23 && value == false) {
        isVisibility = false;
      }
      newRoles.push({
        service_id: role.service_id,
        service_name: role.service_name,
        role_for_read: value,
        role_for_write: value,
        isVisible: isVisibility,
      });
    });
    this.setState({ roles: newRoles });
  };

  handleChange = e => {
    this.setState({
      value: e.target.value,
      action_type: this.props.roleData ? 'UPDATE' : 'ADD_NEW',
      org_role_id: this.props.roleData ? this.props.roleData.role_id : 'NA',
    });
  };

  componentWillReceiveProps(props) {
    if (this.props.roleData && this.props.roleData.service_data) {
      let arr = this.state.roles.map(i => ({ ...i }));
      this.props.roleData.service_data.forEach(itm => {
        if (itm.service_id == 1 && itm.role_for_write == '1') {
          // var data = [...this.state.roles];
          arr[1].isVisible = true;
          this.setState({
            roles: arr,
          });
        }
      });
    }

    this.setState({
      role_status: props.namerole,
      role_status: props.rolestatus,
    });
  }

  addroleSubmitHandler = async e => {
    e.preventDefault();

    const {
      company_id,
      rec_id,
      role_status,
      roles,
      value,
      action_type,
      org_role_id,
    } = this.state;

    const { roleData, onSuccess } = this.props;

    const userdata = {
      comp_id: company_id,
      added_by: rec_id,
      role_status,
      roles,
    };

    if (roleData?.role_name) {
      userdata.action_type = 'UPDATE';
      userdata.org_role_id = roleData.role_id;
      userdata.role_name = value || roleData.role_name;
    } else {
      userdata.action_type = action_type;
      userdata.org_role_id = org_role_id;
      userdata.role_name = value;
    }

    const authToken = JSON.parse(localStorage.getItem('headData'));

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}userRoles/manageRolesByOrg`,
        userdata,
        {
          headers: {
            Authorization: authToken?.spintlyToken,
          },
        },
      );

      if (res?.data?.status === 'success') {
        this.props.onSuccess?.(res.data.message);
        this.setState({ value: '' });
      }
    } catch (err) {
      const status = err?.response?.status;

      if (status === 400) {
        toast.error('Please Fill Details ✍🏻');
      } else if (status === 404) {
        toast.error('URL Not Found 🤷🏻‍♂️');
      } else {
        toast.error('Something Went Wrong 🤬');
      }
    }
  };

  addroleSubmitHandler = e => {
    e.preventDefault();
    let userdata = {};

    if (this.props.roleData && this.props.roleData.role_name !== undefined) {
      userdata.comp_id = this.state.company_id;
      userdata.action_type = 'UPDATE';
      userdata.org_role_id = this.props.roleData
        ? this.props.roleData.role_id
        : 'NA';
      userdata.added_by = this.state.rec_id;
      userdata.role_status = this.state.role_status;
      userdata.roles = this.state.roles;
      userdata.role_name = this.state.value
        ? this.state.value
        : this.props.roleData.role_name;
    } else {
      userdata.comp_id = this.state.company_id;
      userdata.role_name = this.state.value;
      userdata.action_type = this.state.action_type;
      userdata.org_role_id = this.state.org_role_id;
      userdata.added_by = this.state.rec_id;
      userdata.role_status = this.state.role_status;
      userdata.roles = this.state.roles;
    }
    let authToken = JSON.parse(localStorage.getItem('headData'));
    axios
      .post(
        `${process.env.REACT_APP_API_URL}userRoles/manageRolesByOrg`,
        userdata,
        {
          headers: {
            Authorization: authToken?.spintlyToken,
          },
        },
      )
      .then(res => {
        if (res?.data?.status === 'success') {
          this.props.onSuccess?.(res.data.message);
          this.setState({ value: '' });
        }

        mixpanel.track('Role Management Add new Success', {
          PageName: 'Role Management',
          UserEmail: UserObj.email,
          UserName: UserObj.fname + ' ' + UserObj.lname,
          UserId: UserObj.rec_id,
          CompanyId: UserObj.company_id,
          CompanyName: UserObj.company_name,
          Type: 'Role Management',
        });
        mixpanel.track('Role Management Edit Success', {
          PageName: 'Role Management',
          UserEmail: UserObj.email,
          UserName: UserObj.fname + ' ' + UserObj.lname,
          UserId: UserObj.rec_id,
          CompanyId: UserObj.company_id,
          CompanyName: UserObj.company_name,
          Type: 'Role Management',
        });
      })
      .catch(err => {
        if (err) {
          const errcode = err.message.substr(err.message.length - 3);
          if (errcode == 500) {
            // toast.configure();
            toast.error('Something Went Wrong 🤬', {});
          } else if (errcode == 400) {
            toast.error('Please Fill Details ✍🏻', {});
          } else if (errcode == 404) {
            toast.error('Url Not Found 🤷🏻‍♂️', {});
          }
        }
      });

    this.setState({ newuserdata: {} });
  };

  onChangeValue = e => {
    this.setState({
      [e.target.name]: e.target.value,
      action_type: this.props.roleData ? 'UPDATE' : 'ADD_NEW',
      org_role_id: this.props.roleData ? this.props.roleData.role_id : 'NA',
    });
  };

  chkhandleChange = (e, service_id, i, value) => {
    if (service_id == 1 && e.target.value == 'role_for_write') {
      var data = [...this.state.roles];
      data[1].isVisible = e.target.checked;
      this.setState({ data });
    }
    let arr = this.state.roles.map(i => ({ ...i }));
    if (
      e.target.checked == false &&
      service_id == 1 &&
      e.target.value == 'role_for_write'
    ) {
      arr[1].role_for_read = e.target.checked;
      arr[1].role_for_write = e.target.checked;
    }
    if (e.target.value == 'role_for_read') {
      arr[i].role_for_read = e.target.checked;
    } else {
      arr[i].role_for_read = e.target.checked;
      arr[i].role_for_write = e.target.checked;
    }
    this.setState({
      roles: arr,
      //dataarrserver:arryServer,
      action_type: this.props.roleData ? 'UPDATE' : 'ADD_NEW',
      org_role_id: this.props.roleData ? this.props.roleData.role_id : 'NA',
    });
  };

  reload = e => {
    this.setState({
      value: (this.state.newuserdata = ''),
      value: (this.state.userdata = ''),
      value: (this.state.dataarr = ''),
    });
  };

  componentDidMount() {
    let arr = this.state.roles;
    let arrroledata = this.props.roleData
      ? this.props.roleData.service_data
      : [];

    const arryServer = this.state.roles.map(i => ({ ...i }));
    if (arr.length == arrroledata.length) {
      var isSelecetAll = 0;
      arrroledata.map(e => {
        if (e.role_for_read != '1') {
          isSelecetAll = isSelecetAll + 1;
        }
      });
      if (isSelecetAll == 0) {
        this.setState({ selectAll: true });
      }
    } else {
      this.setState({ selectAll: false });
    }
    arrroledata.forEach((element, index) => {
      const objIndex = arr.findIndex(
        obj => obj.service_id == element.service_id,
      );
      if (objIndex > -1) {
        arr[objIndex].role_for_read =
          element.role_for_read === '1' ? true : false;
        arr[objIndex].role_for_write =
          element.role_for_write === '1' ? true : false;
      }
    });
    this.setState({
      role_status: this.props.rolestatus,
    });
  }

  render() {
    const data = [
      { service_id: 1, service_name: 'Manage Members' },
      { service_id: 2, service_name: 'Seat Management' },
      { service_id: 3, service_name: 'Visitor Logs' },
      { service_id: 4, service_name: 'Meeting Room Inventory' },
      { service_id: 5, service_name: 'Company Profile' },
      { service_id: 6, service_name: 'Bills & Invoices' },
      { service_id: 7, service_name: 'Chat with Us' },
      { service_id: 8, service_name: 'Parking Request' },
      { service_id: 9, service_name: 'Leasing' },
      { service_id: 10, service_name: 'E-Cafeteria' },
      { service_id: 12, service_name: 'Seat Planning' },
      { service_id: 13, service_name: 'Manage Roles' },
      { service_id: 14, service_name: 'Department Master' },
      { service_id: 15, service_name: 'Seat Booking Analytics' },
      { service_id: 16, service_name: 'Room Booking Analytics' },
      { service_id: 17, service_name: 'Support Tickets' },
      { service_id: 18, service_name: 'Flexi Seat Analytics' },
      { service_id: 19, service_name: 'MR Analytics' },
      { service_id: 23, service_name: 'Member Approvals' },
      { service_id: 24, service_name: 'Attendance Reports' },
      { service_id: 25, service_name: ' Shift Assigning ' },
      { service_id: 27, service_name: 'Ancillary Sevices' },
      { service_id: 29, service_name: 'Create Booking' },
      { service_id: 28, service_name: 'Meal Plan' },
      // { service_id: 30, service_name: 'Ledger' },
      { service_id: 31, service_name: 'Access Logs' },
    ];

    const listItems = data.map(item => (
      <li key={item.service_name}>{item.service_name}</li>
    ));
    // const listItemsProzo = data.map(item => (
    //   <li key={item.service_name}>{item.service_name}</li>
    // ));

    if (UserObj?.company_id != process.env.REACT_APP_PROZO_COM_ID) {
      data.push({ service_id: 26, service_name: ' Spintly Dashboard' });
    }

    return (
      <>
    
            <div className="row">
              <div className="col-md-12 col-xl-12 col-lg-12">
                <div className="SwFormGroup">
                  <label className="SwFormLabel">Role Title</label>
                  <SwInput
                    type="text"
                    name="Role"
                    placeholder="Please Enter Role"
                    value={
                      this.state.value == null &&
                      this.props.roleData &&
                      this.props.roleData.role_name
                        ? this.props.roleData.role_name
                        : this.state.value
                    }
                    onChange={this.handleChange}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 col-xl-12 col-lg-12">
                <div className="SwFormGroup">
                  <label className="SwFormLabel">Status*</label>
                  <div>
                    <SwRadio
                      id="statusActive"
                      name="role_status"
                      value="1"
                      checked={this.state.role_status === '1'}
                      onChange={this.onChangeValue}
                      label="Active"
                      inline
                    />
                    <SwRadio
                      id="statusInactive"
                      name="role_status"
                      value="2"
                      checked={this.state.role_status === '2'}
                      onChange={this.onChangeValue}
                      label="Inactive"
                      inline
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="SwFormGroup">
              <SwCheckbox
                id="selectAll"
                name="selectAll"
                checked={this.state.selectAll}
                onChange={event => this.selectAll(event.target.checked)}
                label="Select All"
              />
            </div>

            {this.state.roles.map((item, i) =>
              item.isVisible ? (
                <div className="SwFormGroup" key={i}>
                  <label className="SwFormLabel">{item.service_name}</label>
                  <div>
                    <SwCheckbox
                      id={`${item.service_id}_read`}
                      name={item.service_name}
                      value="role_for_read"
                      checked={item.role_for_read}
                      onChange={e =>
                        this.chkhandleChange(
                          e,
                          item.service_id,
                          i,
                          item.role_for_read,
                        )
                      }
                      label="Read"
                      inline
                    />
                    <SwCheckbox
                      id={`${item.service_id}_write`}
                      name={item.service_name}
                      value="role_for_write"
                      checked={item.role_for_write}
                      onChange={e =>
                        this.chkhandleChange(
                          e,
                          item.service_id,
                          i,
                          item.role_for_write,
                        )
                      }
                      label="Write"
                      inline
                    />
                  </div>
                </div>
              ) : null,
            )}
      
      </>
    );
  }
}

export default AddnewRoles;
